import { BaseEnum, BaseEnumItem } from './baseEnum';

const STATUS = new BaseEnum();
STATUS.set('DISABLED', new BaseEnumItem(false, '禁用'));
STATUS.set('ENABLED', new BaseEnumItem(true, '启用'));

export { STATUS };